import {
  ContractDocument,
  ContractNotificationTemplate,
  ContractStatus,
  I2PEnvironment,
  TermWithoutAmount,
} from 'shared/types';
import { ContractUploadFormData } from 'shared/types/forms';
import { buildContractUrl } from 'shared/utility';

export const DEFAULT_CONTRACT: ContractUploadFormData = {
  isBrandOnly: true,
  billToCode: '',
  startDate: '',
  endDate: '',
  files: undefined,
};

export const APPROVAL_EMAILS: Record<I2PEnvironment, string[]> = {
  dev: ['khill@insight2profit.com', 'rlittlejohn@insight2profit.com'],
  sandbox: ['sleonard@insight2profit.com', 'rlittlejohn@insight2profit.com'],
  prod: [
    'jwilson@americanbathgroup.com',
    'jhoagland@americanbathgroup.com',
    'jhollingsworth@americanbathgroup.com',
    'bkorb@americanbathgroup.com',
    'pkinman@americanbathgroup.com',
  ],
  model: [],
};

export const CONTROLLER_BRAND_EMAILS: Record<I2PEnvironment, Record<string, string[]>> = {
  dev: {
    AQUATIC: ['upstart.ksoares@insight2profit.com'],
    'ARIZONA SHOWER DOOR': ['eaquino.upstart@insight2profit.com'],
    BOOTZ: ['upstart.ksoares@insight2profit.com'],
    CLARION: ['eaquino.upstart@insight2profit.com'],
    COASTAL: ['eaquino.upstart@insight2profit.com'],
    DREAMLINE: ['eaquino.upstart@insight2profit.com'],
    FLORESTONE: ['eaquino.upstart@insight2profit.com'],
    IMI: ['upstart.ksoares@insight2profit.com'],
    LAUREL: ['eaquino.upstart@insight2profit.com'],
    MAAX: ['eaquino.upstart@insight2profit.com'],
    'MAAX BATH': ['eaquino.upstart@insight2profit.com'],
    'MAAX SPA': ['eaquino.upstart@insight2profit.com'],
    'MAAX-AKER': ['upstart.ksoares@insight2profit.com'],
    MAIDSTONE: ['eaquino.upstart@insight2profit.com'],
    'MR STEAM': ['eaquino.upstart@insight2profit.com'],
    NEPTUNE: ['eaquino.upstart@insight2profit.com'],
    PRAXIS: ['eaquino.upstart@insight2profit.com'],
    SALO: ['eaquino.upstart@insight2profit.com'],
    SWAN: ['upstart.ksoares@insight2profit.com'],
    VINTAGE: ['eaquino.upstart@insight2profit.com'],
  },
  sandbox: {
    AQUATIC: ['nsaboo@insight2profit.com', 'abgapptesting@gmail.com'],
    'ARIZONA SHOWER DOOR': ['nsaboo@insight2profit.com', 'abgapptesting@gmail.com'],
    BOOTZ: ['upstart.ksoares@insight2profit.com', 'abgapptesting@gmail.com'],
    CLARION: ['eaquino.upstart@insight2profit.com', 'abgapptesting@gmail.com'],
    COASTAL: ['upstart.ksoares@insight2profit.com', 'abgapptesting@gmail.com'],
    DREAMLINE: ['upstart.ksoares@insight2profit.com', 'abgapptesting@gmail.com'],
    FLORESTONE: ['upstart.ksoares@insight2profit.com', 'abgapptesting@gmail.com'],
    IMI: ['nsaboo@insight2profit.com', 'abgapptesting@gmail.com'],
    LAUREL: ['nsaboo@insight2profit.com', 'abgapptesting@gmail.com'],
    MAAX: ['eaquino.upstart@insight2profit.com', 'abgapptesting@gmail.com'],
    'MAAX BATH': ['nsaboo@insight2profit.com', 'abgapptesting@gmail.com'],
    'MAAX SPA': ['nsaboo@insight2profit.com', 'abgapptesting@gmail.com'],
    'MAAX-AKER': ['nsaboo@insight2profit.com', 'abgapptesting@gmail.com'],
    MAIDSTONE: ['eaquino.upstart@insight2profit.com', 'abgapptesting@gmail.com'],
    'MR STEAM': ['eaquino.upstart@insight2profit.com', 'abgapptesting@gmail.com'],
    NEPTUNE: ['nsaboo@insight2profit.com', 'abgapptesting@gmail.com'],
    PRAXIS: ['nsaboo@insight2profit.com', 'abgapptesting@gmail.com'],
    SALO: ['nsaboo@insight2profit.com', 'abgapptesting@gmail.com'],
    SWAN: ['eaquino.upstart@insight2profit.com', 'abgapptesting@gmail.com'],
    VINTAGE: ['nsaboo@insight2profit.com', 'abgapptesting@gmail.com'],
  },
  prod: {
    AQUATIC: [
      'gseaton@praxiscompanies.com',
      'abgapptesting@gmail.com',
      'brichardson@americanbathgroup.com',
      'abgapptesting@gmail.com',
    ],
    'ARIZONA SHOWER DOOR': [
      'Erin.Harakal@dreamline.com',
      'thomas.sherlock@dreamline.com',
      'brichardson@americanbathgroup.com',
      'abgapptesting@gmail.com',
    ],
    BOOTZ: ['rmayes@americanbathgroup.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    CLARION: ['SGeyer@clarionbathware.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    COASTAL: ['jtilbrook@coastalind.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    DREAMLINE: [
      'Erin.Harakal@dreamline.com',
      'thomas.sherlock@dreamline.com',
      'brichardson@americanbathgroup.com',
      'abgapptesting@gmail.com',
    ],
    FLORESTONE: ['gseaton@praxiscompanies.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    IMI: ['gseaton@praxiscompanies.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    LAUREL: ['gseaton@praxiscompanies.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    MAAX: ['Benoit.SavoieDufresne@maax.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    'MAAX BATH': ['Benoit.SavoieDufresne@maax.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    'MAAX SPA': ['astern@maaxspas.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    'MAAX-AKER': ['Benoit.SavoieDufresne@maax.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    MAIDSTONE: ['orine@vintagetub.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    'MR STEAM': ['sislam@mrsteam.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    NEPTUNE: ['Benoit.SavoieDufresne@maax.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    PRAXIS: ['gseaton@praxiscompanies.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    SALO: ['gseaton@praxiscompanies.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    SWAN: ['rmayes@americanbathgroup.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
    VINTAGE: ['orine@vintagetub.com', 'brichardson@americanbathgroup.com', 'abgapptesting@gmail.com'],
  },
  model: {},
};

interface TemplateData {
  contract: ContractDocument;
  comments: string;
}
export const CONTRACT_EMAIL_TEMPLATES: Record<
  ContractNotificationTemplate,
  (data: TemplateData) => { body: string; subject: string }
> = {
  approve: ({ contract, comments }) => ({
    subject: `Contract Change Request Approved for ${contract.customerName}`,
    body: `
    The following change has been approved:

    Contract: ${contract.originalDocumentName}
    Approver: ${contract.approvedBy}

    Comments:
    ${comments}

    To View this contract, click here: ${buildContractUrl(contract)}
    `,
  }),
  request: ({ contract, comments }) => ({
    subject: `Approval Requested by ${contract.modifiedBy} for ${contract.customerName} contract change`,
    body: `
    The following change is being requested:

    Contract: ${contract.originalDocumentName}
    Changed by: ${contract.modifiedBy}

    Comments:
    ${comments}

    To View this deviation, click here: ${buildContractUrl(contract)}
    `,
  }),
  reject: ({ contract, comments }) => ({
    subject: `Contract Change Request Rejected for ${contract.customerName}`,
    body: `
    The following change has been rejected:

    Contract: ${contract.originalDocumentName}
    Changed by: ${contract.modifiedBy}

    Comments:
    ${comments}

    To View this deviation, click here: ${buildContractUrl(contract)}
    `,
  }),
  cancel: ({ contract, comments }) => ({
    subject: `Approval Requested for ${contract.customerName} was cancelled`,
    body: `
    The following change has been canceled:

    Contract: ${contract.originalDocumentName}
    Changed by: ${contract.modifiedBy}

    Comments:
    ${comments}

    To View this deviation, click here: ${buildContractUrl(contract)}
    `,
  }),
  delete: ({ contract }) => ({
    subject: `Approval Requested by ${contract.modifiedBy} for ${contract.customerName} contract delete`,
    body: `
    The following change is being requested:

    Contract: ${contract.originalDocumentName}
    Changed by: ${contract.modifiedBy}

    To View this deviation, click here: ${buildContractUrl(contract)}
    `,
  }),
};

export const CONTRACT_STATUS: Record<ContractStatus, string> = {
  active: 'Active',
  inactive: 'Expired',
  draft: 'Draft',
  rejected: 'Rejected',
  pending: 'Pending Approval',
};

export const CONTRACT_TERMS: TermWithoutAmount[] = [
  {
    name: 'A_MarketingDollars',
    display: 'General Marketing/Advertising Allowance $',
    bucket: 'allowances',
    type: 'dollar',
  },
  {
    name: 'A_DefectiveAllowance',
    display: 'Defective Allowance %',
    bucket: 'allowances',
    type: 'percent',
  },
  {
    name: 'A_DefectiveAllowanceDollars',
    display: 'Defective Allowance $',
    bucket: 'allowances',
    type: 'dollar',
  },
  {
    name: 'A_FreightAllowance',
    display: 'Freight Allowance %',
    bucket: 'allowances',
    type: 'percent',
  },
  {
    name: 'A_FreightAllowanceDollars',
    display: 'Freight Allowance $',
    bucket: 'allowances',
    type: 'dollar',
  },
  {
    name: 'A_TradeAllowance_Discount',
    display: 'Trade Allowance %',
    bucket: 'allowances',
    type: 'percent',
  },
  {
    name: 'A_TradeAllowance_DiscountDollars',
    display: 'Trade Allowance $',
    bucket: 'allowances',
    type: 'dollar',
  },
  {
    name: 'A_DCAllowance',
    display: 'DC Allowance %',
    bucket: 'allowances',
    type: 'percent',
  },
  {
    name: 'A_DCAllowanceDollars',
    display: 'DC Allowance $',
    bucket: 'allowances',
    type: 'dollar',
  },
  {
    name: 'A_InfrastructureAllowance',
    display: 'Infrastructure Allowance %',
    bucket: 'allowances',
    type: 'percent',
  },
  {
    name: 'A_InfrastructureAllowanceDollars',
    display: 'Infrastructure Allowance $',
    bucket: 'allowances',
    type: 'dollar',
  },
  {
    name: 'A_Sharebuilder',
    display: 'Sharebuilder Allowance %',
    bucket: 'allowances',
    type: 'percent',
  },
  {
    name: 'A_SharebuilderDollars',
    display: 'Sharebuilder Allowance $',
    bucket: 'allowances',
    type: 'dollar',
  },
  {
    name: 'A_PACE',
    display: 'PACE Allowance %',
    bucket: 'allowances',
    type: 'percent',
  },
  {
    name: 'A_PACEDollars',
    display: 'PACE Allowance $',
    bucket: 'allowances',
    type: 'dollar',
  },
  {
    name: 'A_Marketing_Advertising',
    display: 'General Marketing/Advertising Allowance %',
    bucket: 'allowances',
    type: 'percent',
  },
  {
    name: 'A_CO-OPDollar',
    display: 'Co-Op $',
    bucket: 'co-op',
    type: 'dollar',
  },
  {
    name: 'A_CO-OPPercent',
    display: 'Co-Op %',
    bucket: 'co-op',
    type: 'percent',
  },
  {
    name: 'A_EDI',
    display: 'EDI Discount %',
    bucket: 'discounts',
    type: 'percent',
  },
  {
    name: 'A_EDIDollars',
    display: 'EDI Discount $',
    bucket: 'discounts',
    type: 'dollar',
  },
  {
    name: 'A_IBX',
    display: 'IBX Discount %',
    bucket: 'discounts',
    type: 'percent',
  },
  {
    name: 'A_IBXDollars',
    display: 'IBX Discount $',
    bucket: 'discounts',
    type: 'dollar',
  },
  {
    name: 'A_MET_MST',
    display: 'MET/MST Discount %',
    bucket: 'discounts',
    type: 'percent',
  },
  {
    name: 'A_MET_MSTDollars',
    display: 'MET/MST Discount $',
    bucket: 'discounts',
    type: 'dollar',
  },
  {
    name: 'A_DSDeduction',
    display: 'DC Deduction %',
    bucket: 'discounts',
    type: 'percent',
  },
  {
    name: 'A_DSDeductionDollars',
    display: 'DC Deduction $',
    bucket: 'discounts',
    type: 'dollar',
  },
  {
    name: 'A_OtherDiscount',
    display: 'Other Discount %',
    bucket: 'discounts',
    type: 'percent',
  },
  {
    name: 'A_PaymentNet',
    display: 'Net Payment (Days)',
    bucket: 'net payment days',
    type: 'text',
  },
  {
    name: 'A_Conversion_RetentionBonusPercent',
    display: 'Conversion/Retention % Bonus',
    bucket: 'other',
    type: 'percent',
  },
  {
    name: 'A_Conversion_RetentionBonus',
    display: 'Conversion/Retention $ Bonus',
    bucket: 'other',
    type: 'dollar',
  },
  {
    name: 'A_PaymentTermsDiscount',
    display: 'Payment Discount %',
    bucket: 'payment terms discount',
    type: 'percent',
  },
  {
    name: 'A_PaymentTermsDiscountDollars',
    display: 'Payment Discount $',
    bucket: 'payment terms discount',
    type: 'dollar',
  },
  {
    name: 'A_PaymentTermsDays',
    display: 'Discount Payment (Days)',
    bucket: 'payment terms discount days',
    type: 'text',
  },
  {
    name: 'VIProjectedRevenue',
    display: 'Projected Volume Incentive Revenue',
    bucket: 'rebates',
    type: 'dollar',
  },
  {
    name: 'VIProjection',
    display: 'Projected Volume Incentive %',
    bucket: 'rebates',
    type: 'percent',
  },
  {
    name: 'GrowthIncentiveProjection',
    display: 'Projected Growth %',
    bucket: 'rebates',
    type: 'percent',
  },
  {
    name: 'GrowthIncentiveProjectionDollars',
    display: 'Projected Growth $',
    bucket: 'rebates',
    type: 'dollar',
  },
  {
    name: 'A_BaseRebate',
    display: 'Base Rebate %',
    bucket: 'rebates',
    type: 'percent',
  },
  {
    name: 'A_BaseRebateDollars',
    display: 'Base Rebate $',
    bucket: 'rebates',
    type: 'dollar',
  },
  {
    name: 'A_ShowRebate',
    display: 'Show Rebate %',
    bucket: 'rebates',
    type: 'percent',
  },
  {
    name: 'A_ShowRebateDollars',
    display: 'Show Rebate $',
    bucket: 'rebates',
    type: 'dollar',
  },
  {
    name: 'A_Rep_Commission',
    display: 'Rep Commission %',
    bucket: 'other',
    type: 'percent',
  },
  {
    name: 'A_Rep_CommissionDollars',
    display: 'Rep Commission $',
    bucket: 'other',
    type: 'dollar',
  },
  {
    name: 'A_OtherDollars',
    display: 'Other $',
    bucket: 'discounts',
    type: 'dollar',
  },
];

export const contractTermsMap = CONTRACT_TERMS.reduce<Record<string, TermWithoutAmount>>((record, contractTerm) => {
  record[contractTerm.name] = contractTerm;
  return record;
}, {} as Record<string, TermWithoutAmount>);
